exports = module.exports = require("../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".editor-container .editor-contenteditable-div{position:relative;left:0;top:0;padding:5px}.editor-container .tab-group .tab-nav{margin:0;padding:0;border-bottom:1px solid #ddd;list-style:none;height:30px;line-height:10px}.editor-container .image-dialog .tab-panel .search-bar .image-searchTxt{display:inline-block!important;width:400px;border:1px solid #c5d2ff;height:25px;line-height:18px;font-size:14px;padding:3px;margin:0;outline:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader/dist/cjs.js!./~/rt-sd-comp/sgiComp/sgiEditor.less
// module id = 1584
// module chunks = 1